// The systems each area's TAGGED ELEMENTS point to, beside the areas on the
// sheet under the model (owner, 2026-10-13: "suggest systems ... from mapped
// construction tracking to areas using the sheet overlay and elements
// tagging per area"). Read-only here: the counts come from GET
// /areas/systems (every element tagged to the area, by the building grid or
// by hand on this page), and accepting them happens on Levels, Areas &
// Systems, which the link opens on that area.
import React, { useEffect, useState } from "react";
import { listAreaSystems } from "api/areas/areasApi";

const fmt = (n) => Number(n || 0).toLocaleString("en-US");

// { [areaId]: row } for the project, or null while loading / on failure.
export function useAreaSystems(projectId, enabled = true) {
  const [byId, setById] = useState(null);
  useEffect(() => {
    let alive = true;
    if (!projectId || !enabled) return undefined;
    const take = (d) => {
      if (!alive) return;
      const m = {};
      ((d && d.areas) || []).forEach((r) => { m[String(r.areaId)] = r; });
      setById(m);
      if (d && d.refreshing) Promise.resolve().then(() => listAreaSystems(projectId, { fresh: true })).then(take).catch(() => {});
    };
    // A failed read leaves the list as it was (names only) - never a crash
    // in the stage's side panel.
    Promise.resolve().then(() => listAreaSystems(projectId)).then(take).catch(() => { if (alive) setById(null); });
    return () => { alive = false; };
  }, [projectId, enabled]);
  return byId;
}

// The one line under an area: "412 tagged · Cable tray 300, Busway 12 ·
// 2 to accept". Pure, for the test.
export function hintText(row) {
  if (!row) return "";
  const n = Number(row.elements) || 0;
  if (!n) return "no elements tagged";
  const sug = (row.suggestions || []).map((s) => `${s.name} ${fmt(s.elements)}${s.state === "accepted" ? " (on the area)" : ""}`);
  const open = (row.suggestions || []).filter((s) => s.state === "new").length;
  const unm = (row.unmapped || []).reduce((t, u) => t + (Number(u.elements) || 0), 0);
  return [
    `${fmt(n)} tagged`,
    sug.length ? sug.join(", ") : "no system",
    unm ? `${fmt(unm)} unmapped` : "",
    open ? `${open} to accept` : "",
  ].filter(Boolean).join(" · ");
}

export function AreaSystemsHint({ projectId, areaId, row }) {
  if (!row) return null;
  const open = (row.suggestions || []).some((s) => s.state === "new");
  return (
    <div style={{ fontSize: 10.5, color: "#6B7280", lineHeight: 1.4, paddingLeft: 16 }} data-testid="area-systems-hint">
      {hintText(row)}
      {open && (
        <>
          {" · "}
          <a href={`/areas/${projectId}?area=${areaId}`} target="_blank" rel="noopener noreferrer">
            Accept on Levels, Areas &amp; Systems
          </a>
        </>
      )}
    </div>
  );
}
